import { StatusConfig, StatusState } from '@gripp/shared-logic';
import { useEffect, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { colors, spacing, tokens } from '../../crop-circle/tokens';
import { ControlledTextInput, useFormContext } from '../../forms';
import { RoutineExecutionFormProps } from '../types';
import { OpenEndedResponse } from './types';
import { Colors } from '../../../themes/colors';

type OpenEndedResponseExecutionProps = RoutineExecutionFormProps<
  StatusConfig,
  StatusState
>;

export const OpenEndedResponseExecutionComponent: React.FC<
  OpenEndedResponseExecutionProps
> = (props: OpenEndedResponseExecutionProps) => {
  const openEndedResponseKey = OpenEndedResponse;
  const statusKey = 'status';
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const selectedStatus = useWatch({
    control,
    name: statusKey,
  });
  const isSelectedOpenEndedResponse = useMemo(
    () => selectedStatus === OpenEndedResponse,
    [selectedStatus]
  );

  useEffect(() => {
    if (
      props.currentState?.state?.openEndedResponse &&
      props?.config?.openEndedResponse
    ) {
      setValue(
        openEndedResponseKey,
        props.currentState.state.openEndedResponse,
        {
          shouldDirty: true,
          shouldValidate: true,
        }
      );
    }
  }, [props.currentState]);

  if (!props.config.openEndedResponse) return null;

  const onStatusChange = (status: string) => {
    setValue(statusKey, status, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <View style={styles.container}>
      <Pressable
        style={[
          styles.button,
          isSelectedOpenEndedResponse && styles.currentStateButton,
        ]}
        onPress={() => {
          onStatusChange(OpenEndedResponse);
        }}
        disabled={props.isIssueEditRoutine}
      >
        {isSelectedOpenEndedResponse ? (
          <ControlledTextInput
            control={control}
            name={openEndedResponseKey}
            placeholder=""
            width={'100%'}
            textColor={colors.brand.white}
            backgroundColor={'transparent'}
            hideBorder
            autoFocus
          />
        ) : (
          <Text style={styles.buttonLabel}>
            {t('routines.status.admin.otherStatus')}
          </Text>
        )}
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: spacing.sm,
  },
  button: {
    height: 52,
    borderRadius: tokens.borderRadius.sm,
    backgroundColor: Colors.role.surfaceInverseSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  currentStateButton: {
    backgroundColor: Colors.role.surfaceInverse,
  },
  buttonLabel: {
    ...tokens.typography.body.medium,
    color: Colors.role.textPrimary,
  },
});
